<script>
  export let tableData = [];
  export let tableHeaders = [];
  export let tableTitle = "Table";
  export let color = "light";
</script>

<div
  class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded {color === 'light' ? 'bg-white' : 'bg-red-800 text-white'}"
>
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3
          class="font-semibold text-lg {color === 'light' ? 'text-blueGray-700' : 'text-white'}"
        >
          {tableTitle}
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <table class="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          {#each tableHeaders as header}
            <th
              class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}"
            >
              {header}
            </th>
          {/each}
        </tr>
      </thead>
      <tbody>
        {#each tableData as row, index}
          <tr class="{index % 2 === 0 ? 'bg-blueGray-50' : 'bg-white'}">
            {#each Object.values(row) as cell, cellIndex}
              <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 {color === 'light' ? 'text-blueGray-600' : 'text-white'}"
              >
                {#if cellIndex === 1 && (cell === 'Activo' || cell === 'Inactivo')}
                  <span class="px-2 py-1 text-xs font-semibold rounded-full {cell === 'Activo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}">
                    {cell}
                  </span>
                {:else}
                  {cell}
                {/if}
              </td>
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
    
    {#if tableData.length === 0}
      <div class="text-center py-8 text-blueGray-500">
        <i class="fas fa-inbox text-4xl mb-4"></i>
        <p>No hay datos disponibles</p>
      </div>
    {/if}
  </div>
</div>
